

function ModeIndication({ mode }) {
    const capitalizedMode = mode.charAt(0).toUpperCase() + mode.slice(1);
  return (
    <div className="modeIndication">{capitalizedMode} Travel</div>
  );
}

export { ModeIndication };